import { defineMessages } from 'react-intl';

export default defineMessages({
    thisWeek: {
        id: 'app.components.datePicker.thisWeek',
        defaultMessage: 'This week'
    },
    lastWeek: {
        id: 'app.components.datePicker.lastWeek',
        defaultMessage: 'Last week'
    },
    thisSchoolYear: {
        id: 'app.components.datePicker.thisSchoolYear',
        defaultMessage: 'This school year'
    },
    customDate: {
        id: 'app.components.datePicker.customDate',
        defaultMessage: 'Custom date'
    }
});



// WEBPACK FOOTER //
// ./app/components/date-picker/messages.js